import { useCallback, useEffect, useMemo, useState } from 'react';
import { I18nContext, detectLocale, getTranslations, type Locale } from '@/i18n';
import { loadRuLocaleBundle } from '@/i18n/loadLocales';
import { GameSessionProvider } from '@/modules/game-session/game-session-context';
import { AppPage } from '@/app/app-page';

export function GameSessionContainer() {
  const [locale, setLocale] = useState<Locale>(() => detectLocale());
  const [ruReady, setRuReady] = useState(locale !== 'ru');
  const translations = useMemo(() => getTranslations(locale), [locale, ruReady]);
  const handleSetLocale = useCallback((l: Locale) => {
    setLocale(l);
    try {
      localStorage.setItem('autohero_locale', l);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    if (locale !== 'ru') {
      setRuReady(true);
      return;
    }
    setRuReady(false);
    let cancelled = false;
    loadRuLocaleBundle()
      .then(() => {
        if (!cancelled) setRuReady(true);
      })
      .catch(() => {
        if (!cancelled) setRuReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, [locale]);

  return (
    <I18nContext.Provider value={{ tr: translations, locale, setLocale: handleSetLocale }}>
      <GameSessionProvider locale={locale} translations={translations}>
        <AppPage />
      </GameSessionProvider>
    </I18nContext.Provider>
  );
}
